import { render, staticRenderFns } from "./ArtworkProofing.vue?vue&type=template&id=7668a95a&"
import script from "./ArtworkProofing.vue?vue&type=script&lang=js&"
export * from "./ArtworkProofing.vue?vue&type=script&lang=js&"
import style0 from "./ArtworkProofing.vue?vue&type=style&index=0&id=7668a95a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports